import React from "react";

export default function SQLServer_ROUND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ROUND</h1>
      <p>This is the SQLServer_ROUND component generated from the SQL JSON.</p>
    </div>
  );
}
